
<script>
import { Line } from 'vue-chartjs'
export default {
  name: "RoomLineChart",
  extends: Line,
  props:['fresh'],
  data () {
    return {
      chartData: {
        labels: ["Babol",	"Cabanatuan",	"Daegu",	"Jerusalem",	"Fairfield",	"New York",	"Gangtok", "Buenos Aires", "Hafar Al-Batin", "Idlib"],
        datasets: [
          {
            label: 'Frequence d\'enregistremenet des séjours',
            data: [600,	1150,	342,	6050,	2522,	3241,	1259,	157,	1545, 9841],
            fill: false,
            borderColor: '#2554FF',
            backgroundColor: '#2554FF',
            borderWidth: 1
          }
        ]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  watch:{
    fresh:function (){
      // alert(this.fresh)
      if (this.fresh===true){
        this.generateStayRecord()
        if (this.$data._chart){
          this.$data._chart.destroy();
        }
        this.chartData.labels = this.roomType
        this.renderChart(this.chartData, this.options)
        this.$emit('succes-stayline-update')
      }
    }
  },
  mounted () {
    setTimeout(()=> {
      this.generateStayRecord()
      this.renderChart(this.chartData, this.options)
    },1000)

  },
methods: {
    generateStayRecord(){
      const stays= JSON.parse(localStorage.getItem('dataRepport')).stay_hebdo
      const start_month = JSON.parse(localStorage.getItem('dataRepport')).start_month
      const end_month = JSON.parse(localStorage.getItem('dataRepport')).end_month
      const start_date = new Date(start_month)
      const end_date = new Date(end_month)
      console.log(start_date.getDate() , end_date.getDate())
      const label =[]
      const datas=[]
      for (let e =start_date.getDate(); e <= end_date.getDate(); e++){
        label.push(start_date.toLocaleDateString('fr-FR'))
        datas.push(stays.filter(item => new Date(item.created_at).toLocaleDateString('fr-FR') == start_date.toLocaleDateString('fr-FR')).length)
        start_date.setDate(start_date.getDate() + 1)
      }
      this.chartData.labels = label
      this.chartData.datasets[0].data = datas
      // console.log(datas)
    }

}
}
</script>
<style scoped>

</style>
